import { v4 as uuid } from "uuid";
import React, { useLayoutEffect, useEffect, useState, useRef} from "react";
import store from "@/redux/store";
import moment from 'moment';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import {FieldHolder} from "@/components/holders/FieldHolder";
import {Button, Calendar, CalendarCell, CalendarGrid, DateInput, DatePicker, DateSegment, Group, Heading, Label, Popover} from 'react-aria-components';
import {PPCDatepicker} from '@/components/datetime/PPCDatepicker';
import { ChevronDownIcon } from '@heroicons/react/16/solid'
import PPCEditor from "@/views/base/editor/Editor"

import { EditorState, RichUtils, convertToRaw, convertFromRaw, convertFromHTML, ContentState, Immutable, Draft   } from 'draft-js';
import { useForm, SubmitHandler } from "react-hook-form"
import { PPCTimeField } from "@/components/datetime/PPCTimeField";
import ListBox from "@/components/holders/ListBox"
import AddAppointmentPanel from "@/views/Agenda/AddAppointmentPanel"
import { Switch, Field } from '@headlessui/react'
import {SearchDossiersPanel} from '@/views/base/search/Dossiers';

import {SelectBox} from '@/components/holders/SelectBox';
import {CustomerSelect} from '@/views/base/search/CustomerSelect';
import {DossierSelect} from '@/views/base/search/DossierSelect';
import { SectorSelect } from "../base/panels/SectorSelect";
import { useTranslation, withTranslation, Trans } from "react-i18next";

import CommunicationCycleReducer, {getState, getTasks, saveTask, newTaskEvent, setChangedItems, setUpdate} from '@/reducers/CommunicationCycle';


export default function AddCalenderItem({...props}) {
    let item = {...props.item}
    if(props?.modalOptions?.dossier_key) {
        item.dossier_key = props?.modalOptions?.dossier_key.trim()
    }
    if(props?.modalOptions?.dossiertask_key) {
        item.task_key = props?.modalOptions?.dossiertask_key.trim()
    }
    
    const editorRed = useRef(null);
    const [refresh, setRefresh] = useState();
    const users = props?.modalOptions?.users;
    const priorities = (props?.modalOptions?.priorities) ? props?.modalOptions?.priorities : false;
  const { register, handleSubmit, watch, reset,    formState, setValue, getValues } = useForm({
      defaultValues: item, values: item,
    })
      const [open, setOpen] = useState(true);
      const [schedule, setSchedule] = useState(false);
        const contentEditor = useRef(null);
    const { t, i18n, ready } = useTranslation();
    
    const onSubmit: SubmitHandler<any> = (data) => {
    if(props.modalOptions.onSaveEvent) {
        props.modalOptions.onSaveEvent(data);
    }
     
      
    return false;

    }
    const scheduleTask = (event) => {
         if(props.modalOptions.checkAvailability) {
             props.modalOptions.checkAvailability(event, moment().valueOf(), getValues('workhours') );
         }
         return false; 
         if(props.modalOptions.scheduleTask) {
             props.modalOptions.scheduleTask( getValues() );
         } 
         setSchedule(true);
    }

     const onCloseEvent = (event) => {
         if(props.modalOptions.onCloseEvent) {
             props.modalOptions.onCloseEvent();
         } 
         setOpen(false);
     }
    const onChangeSectorDepartment = (data1, data2) => {
        if(data1['fields']) {
            for(let i in data1['fields']) {
                setValue(data1['fields'][i], data1['item'][ data1['fields'][i] ]);
            }
        }
    }
    
    const onChangeUserSelection = (data) => {
        setValue("user_key", data?.key);
    }
        const onChangeEvent = (name, selected) => {
            if(name == "dossier") {
            setValue('task_key', null);
            setValue('dossier_key', selected.key);
            setValue('dossier', selected);
            } else if(name == "customer") {
                setValue('customer_key', selected.key);
                setValue('customer', selected);
            } else if(name == "task") {
                setValue('task_key', selected.key);
                //setValue('customer', selected);
            }
            refreshView();
//            setValue('dossier', selected);
            }

    
    const refreshView = () => {
        setRefresh(uuid().slice(0, 8));
    }
    
    return (
        <>
    <Dialog open={open} onClose={(event) => onCloseEvent(event)} className={" z-10 "+((schedule) ? "w-0 h-0 absolute" : " relative")}>
      <DialogBackdrop
        transition
        className={"fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in "+((schedule) ? "w-0 h-0" : "")}
      />
      <div className={"fixed inset-0 z-10 w-screen overflow-y-auto "+((schedule) ? "absolute" : "")}>
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform  rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-3xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
        <form className="" onSubmit={handleSubmit(onSubmit)}>
                                <div className="grid grid-cols-12 gap-3">
                                
                                
                                
<FieldHolder colspan="12" smcolspan="12" id="name" >
    <div className="grid grid-cols-4 items-start gap-2 pb-2">
        <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">{t("event.labels.name_type"+getValues('type'))}</label>
    
         <div className="col-span-3">
            <div className="flex items-center rounded-md bg-white pl-3 outline outline-1 -outline-offset-1 outline-gray-300 has-[input:focus-within]:outline has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-indigo-600">
              <input
                id="name"
                name="name"
                type="text"
                placeholder="inzake"
                {...register("name")}
                className="block min-w-0 grow py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
              />
              <div className="grid shrink-0 grid-cols-1 focus-within:relative">
                <select
                  id="prio"
                  name="prio"
                  aria-label="Prioriteit"
                  onChange={(event)=> {setValue("priority", event.target.value )}}
                  className="col-start-1 row-start-1 w-full appearance-none rounded-md py-1.5 pl-3 pr-7 text-base text-gray-500 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                >
                {priorities && Object.keys(priorities).map((priority, idx) => {
                  return(<option key={idx} value={priorities[priority]} selected={ (getValues('priority') == priorities[priority]) }>{priority}</option>)
                  })}
                </select>
                <ChevronDownIcon
                  aria-hidden="true"
                  className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                />
              </div>
            </div>
          </div>    
    
    
    </div>
</FieldHolder>
</div>

{getValues('type') == 3 && 
    <AddAppointmentPanel {...props} getValues={getValues} setValue={setValue}/>
}          
        
              

    <div className="grid grid-cols-4 items-start gap-2 pb-2">
        <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">{t("event.labels.workhours")} {t("event.type_"+getValues('type'))}</label>
    
         <div className="col-span-3 grid grid-cols-2 gap-2">
            
                    <PPCTimeField onChange={(name, time) => {setValue(name, time);}} name="workhours"  hourCycle={24} defaultValue={getValues('workhours')}/>
        </div>
    </div>        


    <div className="grid grid-cols-4 items-start gap-2 pb-2">
        <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">Datum & tijd</label>
    
         <div className="col-span-3 grid grid-cols-2 gap-2">
            <PPCDatepicker onChangeHandler={setValue} name="start_at" defaultValue={getValues('start_at')}/>
        </div>
    </div>        

    
                <div className="grid grid-cols-4 items-start gap-2 pb-2">
        <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900 sm:pt-1.5">{t("event.labels.declarable")} {getValues('declarable')}</label>

    <Switch
      defaultChecked={ (getValues('declarable')) ? getValues('declarable') : false }
      onChange={(isOn) => {setValue("declarable", isOn);refreshView()}}      
        //onChange={(isOn) => {onChangeAllRightsForChilds("reactions", isOn);}}
        //{onChangeAllRightsForChilds(event,event)} 
      className="group relative mt-3 inline-flex h-4 w-8 flex-shrink-0 cursor-pointer rounded-full border-1 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
    >
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className="pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
      />
    </Switch>
    
    {!props?.modalOptions?.parent && 
    <> 
            <DossierSelect onChangeEvent={onChangeEvent} selected={getValues('dossier_key')} selectedTask={getValues('task_key')} emptyOption={{'key': null, name: "Geen dossier koppeling"}} emptyOptionTask={{'key': null, name: "Geen hoofdtaak"}}/>
            { !getValues('dossier_key') && 
            <>
            <CustomerSelect key={getValues('customer.key')} onChangeEvent={onChangeEvent} selected={getValues('customer.key')} emptyOption={{'key': null, name: "Geen klant gekoppeld"}}/>
            <SectorSelect header="Organisatie en afdeling sector" className="grid grid-cols-12 gap-3 col-span-12" sectors={props?.AuthReducer?.sectors} data={getValues()} onChange={onChangeSectorDepartment}/>
            </>
            }
       
    </>
    }                
</div>

<FieldHolder colspan="12" smcolspan="8" label="Omschrijving" className="max-h-40 h-40" id="name" error={null}>
          <div className="overflow-hidden rounded-lg h-32  outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600">
            <label htmlFor="comment" className="sr-only">
              Omschrijving
            </label>
            <textarea 
              onChange={(event) => {setValue('description', event.target.value);}}
              id="description"
              name="description"
              rows={2}
              placeholder="Omschrijving"
              className="block w-full h-full resize-none bg-transparent px-2 py-2 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
              defaultValue={getValues('description')}
            />
          </div>
</FieldHolder>    
          
          
{users &&
<FieldHolder colspan="12" smcolspan="8" label="Koppel aan gebruiker" className="max-h-40" id="user" error={null}>
            <ListBox selected={getValues('user_key')} data={users} emptyOption dataField={"fullName"} onChange={onChangeUserSelection}/>
</FieldHolder>    
}

       {props?.modalOptions?.parent &&
       <>
          <div className="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0 w-full">
            <dt className="text-sm/6 font-medium text-gray-900">{props?.trans('event.type_'+getValues('type'))} op basis van bestaande {props?.trans('event.type_'+props?.modalOptions?.parent?.type)}</dt>
            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{((props?.modalOptions?.parent?.name) ? props?.modalOptions?.parent?.name : "?")}</dd>
          </div>
          <p className="font-medium text-xs">Onderstaande gegevens worden automatisch gekoppeld aan de nieuwe {props?.trans('event.type_'+getValues('type'))}.<br/>Als u deze gegevens toch wilt aanpassen kunt u beter een nieuwe {props?.trans('event.type_'+getValues('type'))} aanmaken en niet op basis van een bestaande.</p>                 
          <div className="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0 w-full">
            <dt className="text-sm/6 font-medium text-gray-900">Dossier</dt>
            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{((props?.modalOptions?.parent?.dossier) ? props?.modalOptions?.parent?.dossier : "GEEN DOSSIER GEKOPPELD")}</dd>
          </div>                
          <div className="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt className="text-sm/6 font-medium text-gray-900">Klant</dt>
            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{props?.modalOptions?.parent?.customer?.name}</dd>
          </div>                
          <div className="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt className="text-sm/6 font-medium text-gray-900">Sector</dt>
            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{props?.modalOptions?.parent?.customer?.name}</dd>
          </div>                
          <div className="px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt className="text-sm/6 font-medium text-gray-900">Afdeling</dt>
            <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{props?.modalOptions?.parent?.customer?.name}</dd>
          </div>                
       
       </>
        }


          <div className="flex items-center justify-end gap-x-2 border-t border-gray-900/10 mt-2 py-4">
            <button
              type="button"
              onClick={(event) => {scheduleTask(event)}}
              className="hidden rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Direct inplannen
            </button>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>

        </form>
        
         </DialogPanel>
        </div>
      </div>
    </Dialog>
         
        </>
    )   ;
}